<template>
  <v-card :flat="isSettingsStyle">
    <v-card-text>
      <p>{{ $t('body') }}</p>
      <v-select
        v-model="currentPackage"
        :items="paymentPlans"
        :label="$t('package')"
        :rules="[$rules.isRequired]"
        :item-text="planName"
        item-value="alias"
        return-object
        @change="$emit('planChanged', currentPackage)"
      />
    </v-card-text>

    <v-card-actions>
      <v-spacer/>
      <v-btn
        :disabled="isPlanChosen"
        :loading="isLoading"
        color="primary"
        @click="$emit('next', currentPackage)"
      >
        {{ $t(isSettingsStyle? 'changePlan' : 'next') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { toEuro } from '@/utils/customFormatters'
import { mapGetters } from 'vuex'

export default {
  name: 'SubscriptionPlans',
  filters: {
    toEuro
  },
  props: ['isSettingsStyle', 'isLoading'],
  data () {
    return {
      isFormValid: false,
      currentPackage: {},
      paymentPlans: []
    }
  },
  computed: {
    ...mapGetters({
      getUser: 'user/getUser',
      paymentPlansList: 'paymentPlans/paymentPlansList'
    }),
    isPlanChosen () {
      return !Object.keys(this.currentPackage).length
    },
    currentPlanPrice () {
      if (!this.currentPackage) return ''

      const price = this.currentPackage.price
      return price ? toEuro(price / 100) : this.$t('choosePlan')
    }
  },
  methods: {
    setPlans (plans) {
      const p = [...plans]
      p.sort((a, b) => a.price - b.price)
      this.paymentPlans = p || []
    },
    planName (item) {
      const price = toEuro(item.price / 100)
      if (Number(item.max_employees) > 1000) {
        return this.$t('unlimitedPlanName', { price })
      }
      return this.$t('planName', {
        price,
        employees: item.max_employees
      })
    }
  },
  watch: {
    paymentPlansList: {
      handler: 'setPlans',
      immediate: true
    }
  },
  created () {
    if (!this.getUser.subscription_data) return
    const { plan } = this.getUser.subscription_data
    this.currentPackage = plan || {}
  },
  i18n: {
    messages: {
      de: {
        body: 'Hier können Sie ihr aktuelles Abonnement ändern. ',
        package: 'Paket',
        choosePlan: 'Bitte ein Paket wählen',
        packageCost: 'Preis',
        changePlan: 'Paket wechseln',
        planName: '{employees} Mitarbeiter — {price} im Monat',
        unlimitedPlanName: 'Unbegrenzt Mitarbeiter — {price} im Monat',
        next: 'Weiter',
        unlimited: 'Unbegrenzt'
      },
      en: {
        body: 'Here you can change your current subscription.',
        package: 'Package',
        choosePlan: 'Please choose a package',
        packageCost: 'Price',
        changePlan: 'Change package',
        planName: '{employees} employees — {price} a month',
        unlimitedPlanName: 'Unlimited employees — {price} a month',
        next: 'Next'
      },
      tr: {
        body: 'Buradan üyeliğinizi yenileyebilirsiniz.',
        package: 'Paket',
        choosePlan: 'Lütfen bir paket seçiniz',
        packageCost: 'Ücret',
        changePlan: 'Paket değiştirin',
        planName: '{employees} çalışan — {price} aylık',
        unlimitedPlanName: 'Sınırsız çalışan — {price} aylık',
        next: 'Sonraki'
      },
      ru: {
        body: 'Здесь вы можете изменить текущую подписку.',
        package: 'Пакет',
        choosePlan: 'Пожалуйста, выберите паке',
        packageCost: 'Цена',
        changePlan: 'Изменить пакет',
        planName: '{employees} сотрудников — {price} в месяц',
        unlimitedPlanName: 'Неограниченные сотрудники — {price} в месяц',
        next: 'Далее'
      }
    }
  }
}
</script>
